__turbopack_context__.v({
  "calculator": "C8MPZa_calculator",
  "calculator__axis__label": "C8MPZa_calculator__axis__label",
  "calculator__explanation__toggle": "C8MPZa_calculator__explanation__toggle",
  "calculator__explanation__toggle_open": "C8MPZa_calculator__explanation__toggle_open",
  "calculator__impact": "C8MPZa_calculator__impact",
  "calculator__impact__description": "C8MPZa_calculator__impact__description",
  "calculator__impact__description__button_desktop": "C8MPZa_calculator__impact__description__button_desktop",
  "calculator__impact__description__button_mobile": "C8MPZa_calculator__impact__description__button_mobile",
  "calculator__impact__output": "C8MPZa_calculator__impact__output",
  "calculator__input": "C8MPZa_calculator__input",
  "calculator__input__calculate__label": "C8MPZa_calculator__input__calculate__label",
  "calculator__input__calculate__spinner": "C8MPZa_calculator__input__calculate__spinner",
  "calculator__input__group": "C8MPZa_calculator__input__group",
  "calculator__input__group__input__income__wrapper": "C8MPZa_calculator__input__group__input__income__wrapper",
  "calculator__input__group__input__text": "C8MPZa_calculator__input__group__input__text",
  "calculator__input__group__percentage_input": "C8MPZa_calculator__input__group__percentage_input",
  "calculator__input__group__percentage_input_wrapper": "C8MPZa_calculator__input__group__percentage_input_wrapper",
  "calculator__input__group__percentage_text": "C8MPZa_calculator__input__group__percentage_text",
  "calculator__input__group_mobile": "C8MPZa_calculator__input__group_mobile",
  "calculator__input__inner": "C8MPZa_calculator__input__inner",
  "calculator__input_slider": "C8MPZa_calculator__input_slider",
  "calculator__output": "C8MPZa_calculator__output",
  "calculator__output__chart": "C8MPZa_calculator__output__chart",
  "calculator__output__spinner": "C8MPZa_calculator__output__spinner",
  "wrapper": "C8MPZa_wrapper",
});
